const convertPageArrayToTree = (pages, rootPageId) => {
  if (!rootPageId) return [];
  const pageIdsInRootTree = [rootPageId];
  const mapChildren = ({ id }, { parent, ancestors }) => {
    pageIdsInRootTree.push(id);
    // do not process a page with a blank slug unless it's the root page
    const page = pages.find((p) => p.id === id
      && ((ancestors.length === 0 && id === rootPageId) || p.slug));
    if (page) {
      const { slug, children, title } = page;
      const { id: parentId, path: parentPath } = parent || {};
      let path;
      if (parentPath) {
        path = `${parentPath}${slug || ''}/`;
      } else {
        path = slug ? `/${slug}/` : '/';
      }
      const child = {
        id,
        title,
        parentId,
        path,
        ancestors,
        children: children ? children
          // a page can never be a child of itself
          // an ancestor cannot also be a child
          .filter((p) => p.id !== id && !ancestors.includes(p.id))
          .map((p) => mapChildren(p,
            { parent: { id, path }, ancestors: [...ancestors, id] })) : null,
      };
      return child;
    }
    return null;
  };

  const rootPages = pages.filter(({ id }) => id === rootPageId);
  const treeWithRoot = rootPages.map((p) => mapChildren(p, { parent: null, ancestors: [] }));
  // also include orphans: the pages that were passed in but were not a child of any page
  const orphanedPages = pages.filter(({ id, slug }) => slug && !pageIdsInRootTree.includes(id))
    .map((p) => mapChildren(p, { parent: null, ancestors: [] }));
  return [...treeWithRoot, ...orphanedPages];
};

// recursively reduce the tree to a flattened list of pages and their paths
const flattenPageTree = (pageTree) => {
  const flattenReducer = (obj, item) => {
    const newObj = obj;
    const {
      id, children, path, parentId, ancestors,
    } = item;
    const paths = newObj[id] || [];
    paths.push({
      path, parentId, ancestors, children,
    });
    if (!newObj[id]) {
      newObj[id] = paths;
    }
    if (children && children.length > 0) {
      return children.reduce(flattenReducer, newObj);
    }
    return newObj;
  };

  return pageTree.reduce(flattenReducer, {});
};

exports.convertPageArrayToTree = convertPageArrayToTree;
exports.flattenPageTree = flattenPageTree;
